export var MaintenanceMetricUnit;
(function (MaintenanceMetricUnit) {
    MaintenanceMetricUnit["MAINTENANCE_METRIC_UNIT_UNSPECIFIED"] = "MAINTENANCE_METRIC_UNIT_UNSPECIFIED";
    MaintenanceMetricUnit["MAINTENANCE_METRIC_UNIT_BYTES"] = "BYTES";
    MaintenanceMetricUnit["MAINTENANCE_METRIC_UNIT_COUNT"] = "COUNT";
    MaintenanceMetricUnit["MAINTENANCE_METRIC_UNIT_SECONDS"] = "SECONDS";
    MaintenanceMetricUnit["MAINTENANCE_METRIC_UNIT_MILLISECONDS"] = "MILLISECONDS";
    MaintenanceMetricUnit["MAINTENANCE_METRIC_UNIT_RATIO"] = "RATIO";
    MaintenanceMetricUnit["MAINTENANCE_METRIC_UNIT_PERCENT"] = "PERCENT";
})(MaintenanceMetricUnit || (MaintenanceMetricUnit = {}));
